import React from 'react';

import { Breadcrumbs, Skeleton } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';

const Placeholder = () => (
    <Breadcrumbs>
        {[...Array(2)].map((_, index) => (
            <Skeleton
                width={150}
                key={`skeleton-${Math.random() + index}`}
            ></Skeleton>
        ))}
    </Breadcrumbs>
);

const PlaceholderBreadcrumbs = ({ children, ready }) => {
    return ready ? <Placeholder /> : children;
};

PlaceholderBreadcrumbs.propTypes = {
    children: PropTypes.node,
    ready: PropTypes.bool,
};

export default PlaceholderBreadcrumbs;
